module.exports = __webpack_public_path__ + "img/img_banner.370e1715.png";